import { produce } from 'immer';
import { RootState } from '../store';
import { createDraftSafeSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PhoneINT, PHONE_BUTTONS } from '../../components/phoneUI/PhoneClass';
import { TCharacter, TimageINT, TquestionFormat, TquestionINT, TtalkStateINT } from './gameObjectSlice';
import Question from '../../shell/Questions';

export interface TPhoneContact {
    name: string,
    profileImage?: TimageINT,
    wallpaper?: Partial<TimageINT>,
}
export enum PhoneTypes {
    MESSAGE = `MESSAGE`,
    QUESTION = `QUESTION`,
    IMAGE = `IMAGE`
}
// export interface PhoneTypes {
//     message: TtalkStateINT,
//     image: TimageINT,
//     question: TquestionINT,
// }
export interface phoneObjects {
    type: PhoneTypes,
    content: (TtalkStateINT | TimageINT | TquestionFormat) & { character: TCharacter; };
}
export interface PhoneQuestionFormat {
    character: TCharacter,
    question: Question;
}
export interface ContactsUI {

    selectedContact: TPhoneContact | null,
    contacts?: TPhoneContact[],
    // message?: TtalkStateINT,
    history?: phoneObjects[],
    phoneObjects?: phoneObjects;

}

export enum PhoneStyle {
    NORMAL = `NORMAL`,
    INSTA = 'INSTA',
}

export interface TPhoneINT {
    display: boolean,
    style?: PhoneStyle,
    displayMessagesUI: boolean,
    images?: PhoneINT,
    image?: TimageINT,
    buttons: PHONE_BUTTONS[],
    comment?: TtalkStateINT,
    contactsInfo: ContactsUI,
    counter?: number,
}

const initialState: TPhoneINT = { display: false, displayMessagesUI: false, style: PhoneStyle.NORMAL, contactsInfo: { selectedContact: null }, buttons: [], comment: { text: '' } };
const phoneSlice = createSlice({
    name: 'phone',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setPhone: (state, { payload }: PayloadAction<TPhoneINT>) => {
            return { ...state, ...payload };
        },
        setPhoneDisplay: (state, { payload }: PayloadAction<Partial<TPhoneINT>>) => {
            return produce(state, draft => {
                draft.display = payload.display != null ? payload.display : draft.display;
                draft.displayMessagesUI = payload.displayMessagesUI != null ? payload.displayMessagesUI : draft.displayMessagesUI;
                draft.style = payload.style || PhoneStyle.NORMAL;
                draft.comment!.text = '';
                if (draft.displayMessagesUI === false) {

                    draft.contactsInfo.history = undefined;
                }

            });
        },
        showMessagesUI: (state, { payload }: PayloadAction<ContactsUI>) => {
            return produce(state, draft => {
                draft.contactsInfo = { ...draft.contactsInfo, ...payload };
            });
        },

        setPhoneMessage: (state, { payload }: PayloadAction<TtalkStateINT & { character: TCharacter; }>) => {
            return produce(state, draft => {
                // draft.contactsInfo.message = { ...draft.contactsInfo.message, ...payload };
                if (draft.contactsInfo.phoneObjects?.content) {
                    draft.contactsInfo.phoneObjects.content = payload;
                    draft.contactsInfo.phoneObjects.type = PhoneTypes.MESSAGE;
                }

                draft.contactsInfo.history = [...draft.contactsInfo.history || [], { content: payload, type: PhoneTypes.MESSAGE }];
            });
        },
        setPhoneImage: (state, { payload }: PayloadAction<TimageINT & { character: TCharacter; }>) => {
            return produce(state, draft => {
                // draft.contactsInfo.message = { ...draft.contactsInfo.message, ...payload };
                if (draft.contactsInfo.phoneObjects?.content) {
                    draft.contactsInfo.phoneObjects.content = payload;
                    draft.contactsInfo.phoneObjects.type = PhoneTypes.IMAGE;
                }

                draft.contactsInfo.history = [...draft.contactsInfo.history || [], { content: payload, type: PhoneTypes.IMAGE }];
            });
        },
        setPhoneQuestion: (state, { payload }: PayloadAction<TquestionFormat & { character: TCharacter; }>) => {
            return produce(state, draft => {
                // draft.contactsInfo.message = { ...draft.contactsInfo.message, ...payload };
                if (draft.contactsInfo.phoneObjects?.content) {
                    draft.contactsInfo.phoneObjects.content = payload;
                    draft.contactsInfo.phoneObjects.type = PhoneTypes.QUESTION;
                }

                draft.contactsInfo.history = [...draft.contactsInfo.history || [], { content: payload, type: PhoneTypes.QUESTION }];
            });
        },
        setHistory: (state, { payload }: PayloadAction<phoneObjects | undefined>) => {
            return produce(state, draft => {

                draft.contactsInfo.history = payload ? [...draft.contactsInfo.history || [], payload] : payload;
            });
        },
        setPhoneComment: (state, { payload }: PayloadAction<TtalkStateINT>) => {
            return produce(state, draft => {
                draft.comment = { ...payload };
            });
        },
        setPhoneButtons: (state, { payload }: PayloadAction<PHONE_BUTTONS[]>) => {
            return produce(state, draft => {
                draft.buttons = payload;
            });
        },
        clearHistory: (state) => {
            return produce(state, draft => {
                draft.counter = (draft.counter || 0) + 1;
            });
        },

    },

});

export const { setPhone, setPhoneMessage, setPhoneDisplay, clearHistory, showMessagesUI, setPhoneImage, setPhoneQuestion, setHistory, setPhoneComment, setPhoneButtons } = phoneSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectPhone = (state: RootState) => state.phone;
export const selectContacts = (state: RootState) => state.phone.present.contactsInfo;


export default phoneSlice.reducer;
